import { html } from 'lit';
import { EyeOff } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-eye-off')
export class PdsIconEyeOff extends PdsIcon {
  @state()
  icon = EyeOff;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
